import { useStore } from 'effector-react'
import * as React from 'react'

import { $operations, getBalanceOperations, operationsMounted } from './model'

export const useBalanceOperationsWidget = () => {
  React.useEffect(() => {
    operationsMounted()
  }, [])

  const operations = useStore($operations)

  const loading = useStore(getBalanceOperations.pending)

  return {
    operations,
    loading,
  }
}
